import { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Hymn, IssueTag } from '../../../common/src/model.ts';
import * as server_api from '../../../common/src/server_api.ts';
import CloseIcon from '../assets/close.svg?react';
import { LocalStorageKey } from '../data/client_local_storage.ts';
import { useLocalStorage } from '../data/use_local_storage.tsx';
import '../util/shared.css';
import './report_song_issue.css';
import './song_info.css';

interface Props {
  visible: boolean;
  hymn?: Hymn;
  close?: () => void;
}

export const ReportSongIssue = ({ visible, hymn, close }: Props) => {
  const [isPlayerMaximized] = useLocalStorage(LocalStorageKey.IsPlayerMaximized);

  useEffect(() => {
    if (!visible) return;
    document.getElementById('modal')?.classList.add('active');
    document.getElementById('modal-backdrop')?.classList.add('active');
  }, [visible]);

  const onClose = useCallback(() => {
    document.getElementById('modal')?.classList.remove('active');
    document.getElementById('modal-backdrop')?.classList.remove('active');
    close?.();
  }, [close]);

  useEffect(() => {
    if (!isPlayerMaximized) {
      onClose();
    }
  }, [onClose, isPlayerMaximized]);

  function getSelectValue(elmId: string) {
    const elem = document.getElementById(elmId);
    if (typeof elem !== 'undefined' && elem !== null) {
      return (elem as HTMLSelectElement).value;
    } else {
      return '';
    }
  }

  function getInputValue(elmId: string) {
    const elem = document.getElementById(elmId);
    if (typeof elem !== 'undefined' && elem !== null) {
      return (elem as HTMLInputElement).value;
    } else {
      return '';
    }
  }

  function getDescription(elmId: string) {
    const elem = document.getElementById(elmId);
    if (typeof elem !== 'undefined' && elem !== null) {
      return (elem as HTMLTextAreaElement).value;
    } else {
      return '';
    }
  }

  const recordIssue = useCallback(() => {
    void server_api.addIssue({
      hymnalName: hymn?.hymnal,
      songNumber: hymn?.songNumber,
      description: {
        tag: getSelectValue('problemTag') as IssueTag.WrongNote | IssueTag.Tempo | IssueTag.Other,
        voice: getSelectValue('voice'),
        measure: getInputValue('problemMeasure'),
        description: getDescription('descriptionBox'),
      },
      timestamp: Date.now(),
    });
  }, [hymn]);

  function submit() {
    recordIssue();
    onClose();
  }

  return (
    <ReportSongIssueWrapper>
      <div id="modal" style={{ width: 350, height: 350 }}>
        <CloseButton onClick={onClose} />
        <div style={{ position: 'relative', height: '95%', width: '100%', marginTop: 20 }}>
          <div id="heading">Report an Issue</div>
          <div id="reportContent">
            <div id="reportLabels">
              <div style={{ width: '33.33%', position: 'relative' }}>
                <select id="problemTag">
                  <option disabled value={''}>
                    Area
                  </option>
                  <option id="option" value={IssueTag.WrongNote}>
                    Wrong Note
                  </option>
                  <option value={IssueTag.Tempo}>Tempo</option>
                  <option value={IssueTag.Other}>Other</option>
                </select>
              </div>

              <div style={{ width: '33.33%', position: 'relative' }}>
                <select id="voice">
                  <option disabled value={''}>
                    Voice
                  </option>
                  <option value={'all'}>All</option>
                  <option value={'soprano'}>Soprano</option>
                  <option value={'alto'}>Alto</option>
                  <option value={'tenor'}>Tenor</option>
                  <option value={'bass'}>Bass</option>
                  <option value={'n/a'}>n/a</option>
                </select>
              </div>

              <div style={{ width: '33.33%', position: 'relative' }} />
            </div>

            <div style={{ width: '100%', height: 45, marginLeft: 30 }}>
              <div id="measureContainer">
                <div style={{ fontSize: '17px', marginLeft: '2px', lineHeight: '30px' }}>Measure:</div>
                <input type="text" id="problemMeasure" />
              </div>
            </div>

            <div id="description">
              <div id="descriptionLabel">Description:</div>
              <form>
                <textarea id="descriptionBox" />
              </form>
            </div>
            <button id="submitButton" onClick={() => submit()}>
              Submit
            </button>
          </div>
        </div>
      </div>
      <div id="modal-backdrop" onClick={() => onClose()}></div>
    </ReportSongIssueWrapper>
  );
};

const ReportSongIssueWrapper = styled.div``;

const CloseButton = styled(CloseIcon)`
  z-index: 101;
  cursor: pointer;
  width: 25px;
  height: 25px;
  position: absolute;
  top: 10px;
  right: 10px;
  fill: var(--color-text);
`;
